export default "__VITE_ASSET__DNEH7yQZ__"